module.exports = __webpack_public_path__ + "static/media/logotipo-branco.8de70c4a.png";